import { Router, Switch, Route, Redirect } from 'wouter'
import HomePage from '@/pages/HomePage'
import AboutPage from '@/pages/AboutPage'
import ContactPage from '@/pages/ContactPage'
import GetInTouchPage from '@/pages/GetInTouchPage'
import DonatePage from '@/pages/DonatePage'
import SubscribePage from '@/pages/SubscribePage'
import PartnersPage from '@/pages/PartnersPage'
import ResourcesPage from '@/pages/ResourcesPage'
import TellMeMorePage from '@/pages/TellMeMorePage'
import BlogPage from '@/pages/BlogPage'

function App() {
  return (
    <Router base={import.meta.env.VITE_ROUTER_BASE ?? '/spoke-movie'}>
      <div className="min-h-screen bg-black text-white">
        <Switch>
          <Route path="/" component={HomePage} />
          <Route path="/about" component={AboutPage} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/get-in-touch" component={GetInTouchPage} />
          <Route path="/dosomething" component={DonatePage} />
          <Route path="/support"><Redirect to="/dosomething" replace /></Route>
          <Route path="/subscribe" component={SubscribePage} />
          <Route path="/partners" component={PartnersPage} />
          <Route path="/resources" component={ResourcesPage} />
          <Route path="/tell-me-more" component={TellMeMorePage} />
          <Route path="/blog" component={BlogPage} />
          <Route>
            <HomePage />
          </Route>
        </Switch>
      </div>
    </Router>
  )
}

export default App